// @ts-nocheck
/* Starter Sync - MyListsDetailsTotal */

import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import resetWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/ResetWishLists";
import {
    getWishListState,
    getWishListTotal,
    getWishListTotalWithVat,
} from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import removeWishListTags from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/RemoveWishListTags";
import translate from "@insite/client-framework/Translate";
import { WishListTagModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import WishListSharingStatus, {
    WishListSharingStatusStyles,
} from "@insite/content-library/Components/WishListSharingStatus";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import X from "@insite/mobius/Icons/X";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
// import React from "react"; // Starter Custom Code
// import { connect } from "react-redux"; // Starter Custom Code
import { useDispatch } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import setWishListTags from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetWishListTags";
import AddTagsModal from "@insite/content-library/Widgets/MyListsDetails/AddTagsModal";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Tag from "@insite/mobius/Tag";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { infoProps } from "@store/Themes/common/props/info";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { productLineProps } from "@store/Themes/common/props/productLine";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const labelProps = mergeProps<TypographyPresentationProps>(infoProps.label, { forwardAs: "h2" });
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    const wishListLinesDataView = getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter);

    return {
        wishList: getWishListState(state, state.pages.myListDetails.wishListId).value,
        wishListTotal: getWishListTotal(wishListLinesDataView, state.pages.myListDetails.productInfosByWishListLineId),
        language: state.context.session.language,
        enableVat: getSettingsCollection(state).productSettings.enableVat,
        vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
        wishListTotalWithVat: getWishListTotalWithVat(
            wishListLinesDataView,
            state.pages.myListDetails.productInfosByWishListLineId,
        ),
        showPricing: state.context.showPricing,
        removingWishListTags: state.pages.myListDetails.removingWishListTags,
    };
};

/* Starter Custom Code - Start */
const mapDispatchToProps = {
    setWishListTags,
};
/* Starter Custom Code - End */

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Starter Custom Code

export interface MyListsDetailsHeaderStyles {
    container?: GridContainerProps;
    infoGridItem?: GridItemProps;
    lastUpdateText?: TypographyProps;
    wishListHiddenText?: TypographyProps;
    sharingStatus?: WishListSharingStatusStyles;
    shareText?: TypographyProps;
    lineCountText?: TypographyProps;
    totalText?: TypographyProps;
    totalVatLabelText?: TypographyPresentationProps;
    totalWithoutVatText?: TypographyPresentationProps;
    totalWithoutVatLabelText?: TypographyPresentationProps;
    descriptionGridItem?: GridItemProps;
    descriptionStyles?: SmallHeadingAndTextStyles;
    tagsGridItem?: GridItemProps;
    tagText?: TypographyProps;
    tagCloseText?: TypographyProps;
    // Starter Custom Code
    dateLabel?: TypographyPresentationProps;
    descriptionLabel?: TypographyPresentationProps;
    descriptionText?: TypographyPresentationProps;
    tagsHeadingWrapper?: InjectableCss;
    tagsLabel?: TypographyPresentationProps;
    tagsAddLink?: LinkPresentationProps;
    tagsRemoveAllLink?: LinkPresentationProps;
    tagWrapper?: TagWrapperProps;
}

export const headerStyles: MyListsDetailsHeaderStyles = {
    container: mergeProps<MyListsDetailsHeaderStyles["container"]>(infoProps.grid?.container, {
        css: css`
            ${x => spacingStyles(null, x.theme.design.typography.spacing.larger)};
        `,
    }),
    descriptionGridItem: infoProps.grid?.fullItem,
    infoGridItem: infoProps.grid?.item,
    dateLabel: labelProps,
    lastUpdateText: infoProps.value,
    descriptionLabel: labelProps,
    descriptionText: infoProps.value,
    totalText: labelProps,
    totalVatLabelText: productLineProps.subtotalVatLabel,
    totalWithoutVatText: infoProps.value,
    totalWithoutVatLabelText: productLineProps.subtotalVatLabel,
    tagsGridItem: infoProps.grid?.fullItem,
    tagsHeadingWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            ${x => spacingStyles(null, x.theme.design.typography.spacing.small)}
        `,
    },
    tagsLabel: mergeProps<MyListsDetailsHeaderStyles["tagsLabel"]>(labelProps, {
        css: css`
            ${x => inlineSeparatorStyles({ spacing: x.theme.design.typography.spacing.small, width: "0px" })}
        `,
    }),
    tagsAddLink: mergeProps<MyListsDetailsHeaderStyles["tagsAddLink"]>(linkGetActionLinkProps(PlusCircleFill), {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smallest};
            ${x => inlineSeparatorStyles()}
        `,
    }),
    tagsRemoveAllLink: mergeProps<MyListsDetailsHeaderStyles["tagsRemoveAllLink"]>(linkGetActionLinkProps(TrashFill), {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smallest};
        `,
    }),
};

const styles = headerStyles;

const MyListsDetailsHeader = ({
    wishList,
    wishListTotal,
    language,
    enableVat,
    vatPriceDisplay,
    wishListTotalWithVat,
    showPricing,
    removingWishListTags,
}: Props) => {
    if (!wishList) {
        return null;
    }

    const dispatch = useDispatch();
    const updatedOnDisplay = getLocalizedDateTime({
        dateTime: new Date(wishList.updatedOn),
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    /* Starter Custom Code - Start */
    const [addTagsModalIsOpen, setAddTagsModalIsOpen] = useState(false);

    const lastUpdatedDisplay =
        wishList.updatedByDisplayName && !wishList.isAutogenerated
            ? ` ${translate("by")} ${wishList.updatedByDisplayName}`
            : null;

    const addTagsClickHandler = () => {
        setAddTagsModalIsOpen(true);
    };

    const closeAddTagsModalHandler = () => {
        setAddTagsModalIsOpen(false);
        const tags = wishList?.wishListTags?.map(o => o.tag);
        if (tags) {
            setWishListTags({ wishListTags: tags });
        }
    };
    /* Starter Custom Code - End */

    const removeTag = (wishListTag?: /* Starter Custom Code - added "?" */ WishListTagModel) => {
        if (!removingWishListTags) {
            /* Starter Custom Code - Start */
            const tag = wishListTag
                ? [wishListTag.id]
                : wishList.wishListTags?.map(wishListTag => {
                      return wishListTag.id;
                  }) || [];
            /* Starter Custom Code - End */

            dispatch(
                removeWishListTags({
                    wishListId: wishList.id,
                    wishListTagIds: tag, // Starter Custom Code
                    onComplete: () => dispatch(resetWishLists()),
                }),
            );
        }
    };

    return (
        <GridContainer {...styles.container}>
            {/* Starter Custom Code - Start */}
            {updatedOnDisplay ? (
                <GridItem {...styles.infoGridItem} data-test-selector="lastUpdate">
                    <Typography {...styles.dateLabel}>{translate("Last Updated")}</Typography>
                    <Typography {...styles.lastUpdateText}>
                        {updatedOnDisplay}
                        {lastUpdatedDisplay ? ` ${lastUpdatedDisplay}` : null}
                    </Typography>
                    {wishList.isHidden && (
                        <Typography {...styles.wishListHiddenText}>{translate("List is hidden")}</Typography>
                    )}
                </GridItem>
            ) : null}
            {/* Starter Custom Code - End */}
            <GridItem {...styles.infoGridItem}>
                <Typography {...styles.dateLabel} /* Starter Custom Code */>{translate("Status")}</Typography>
                <WishListSharingStatus
                    extendedStyles={styles.sharingStatus}
                    showNoPermissionsTooltip={true}
                    wishList={wishList}
                />
                {/* Starter Removed - wishListTotal !== undefined */}
            </GridItem>
            {wishList.description && (
                <GridItem {...styles.descriptionGridItem}>
                    {/* Starter Removed - SmallHeadingAndText  */}
                    {/* Starter Custom Code - Start */}
                    <Typography {...styles.descriptionLabel}>{translate("Description")}</Typography>
                    <Typography {...styles.descriptionText}>{wishList.description}</Typography>
                    {/* Starter Custom Code - End */}
                </GridItem>
            )}
            {/* Starter Custom Code - Start */}
            {!wishList.isAutogenerated && (
                <GridItem {...styles.tagsGridItem}>
                    <StyledWrapper {...styles.tagsHeadingWrapper}>
                        <Typography {...styles.tagsLabel}>{translate("Tags")}</Typography>
                        <Link {...styles.tagsAddLink} onClick={() => addTagsClickHandler()}>
                            {translate("Add Tags")}
                        </Link>
                        {wishList.wishListTags && wishList.wishListTags.length > 0 ? (
                            <Link {...styles.tagsRemoveAllLink} onClick={() => removeTag()}>
                                {translate("Remove All")}
                            </Link>
                        ) : null}
                    </StyledWrapper>
                    {wishList.wishListTags && wishList.wishListTags.length > 0 && (
                        <TagWrapper {...styles.tagWrapper}>
                            {wishList.wishListTags.map(wishListTag => (
                                <Tag
                                    key={wishListTag.tag}
                                    onDelete={() => removeTag(wishListTag)}
                                    data-test-selector={`tagItem_${wishListTag.tag}`}
                                >
                                    {wishListTag.tag}
                                </Tag>
                            ))}
                        </TagWrapper>
                    )}
                </GridItem>
            )}
            <AddTagsModal isOpen={addTagsModalIsOpen} handleClose={closeAddTagsModalHandler} />
            {/* Starter Custom Code - End */}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyListsDetailsHeader), // Starter Custom Code
    definition: {
        group: "My Lists Details",
        displayName: "Information", // Starter Custom Code
        allowedContexts: ["MyListsDetailsPage"],
    },
};

export default widgetModule;
